import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import HttpsProtocolImage from '../../component/common/https-protocol-image';
import BuildOrderBtn from '../../component/dish-menu/build-order-btn';

import helper from '../../helper/dish-helper';
import FormattedMessage from '../../intl/formatted-message';
import dishMenuText from '../../intl/messages/dish-menu';

import './self-choose-must-order.scss';

export default class SelfChooseMustOrder extends React.Component {
  static propTypes = {
    selfChooseDishList: PropTypes.arrayOf(PropTypes.object).isRequired,
    orderedDishes: PropTypes.arrayOf(PropTypes.object).isRequired, // 已点菜列表
    onConfirm: PropTypes.func.isRequired,
    onPropsBtnTap: PropTypes.func.isRequired,
    onOrderBtnTap: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  onBtnTap = (dish, newCount, increment) => {
    const { onOrderBtnTap, onPropsBtnTap } = this.props;

    if (increment) {
      onOrderBtnTap(dish, increment);
    } else {
      onPropsBtnTap(dish);
    }
  };

  getDishList = () => {
    const { orderedDishes, selfChooseDishList } = this.props;
    // 收集已点的数据
    const orderedDishesMap = orderedDishes.reduce((t, { brandDishId, order }) => {
      if (t[brandDishId]) {
        t[brandDishId] = typeof order === 'number' ? t[brandDishId] + order : t[brandDishId].concat(order);
      } else {
        t[brandDishId] = order;
      }
      return t;
    }, {});

    return selfChooseDishList.map(dish => {
      return {
        ...dish,
        order: orderedDishesMap[dish.brandDishId] || dish.order,
      };
    });
  };

  render() {
    const dishList = this.getDishList();
    const count = helper.getDishesCount(dishList);

    return (
      <div className="self-choose">
        <div className="self-choose-mask" />
        <div className="self-choose-modal">
          <div className="self-choose-modal-title">
            <FormattedMessage {...dishMenuText.selfChooseModalTitle} />
          </div>
          <div className="self-choose-modal-body">
            {dishList.map(dish => {
              const img = dish.smallImgUrl || (dish.largeImgList && dish.largeImgList[0]);
              const bgStyle = img
                ? {
                    background: `center/100% url(${HttpsProtocolImage.getFinalImageUrl(img)}) no-repeat`,
                  }
                : {};
              return (
                <div className="self-choose-dish" key={dish.id}>
                  <div
                    className={classnames('self-choose-dish-img', {
                      'self-choose-dish-img-default': !img,
                    })}
                    style={bgStyle}
                  />
                  <div className="self-choose-dish-name">{dish.name}</div>
                  <div className="self-choose-dish-price price">{dish.marketPrice}</div>
                  <div className="self-choose-dish-counter">
                    <BuildOrderBtn
                      dishData={dish}
                      isClear={dish.clearStatus}
                      onBtnTap={(...rest) => {
                        this.onBtnTap(dish, ...rest);
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={classnames('self-choose-modal-footer', {
              'self-choose-modal-footer-disabled': !count,
            })}
            onClick={() => {
              if (count > 0) {
                this.props.onConfirm();
              }
            }}
          >
            <FormattedMessage {...dishMenuText.selfChooseModalFooter} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/dish-menu/self-choose-must-order.jsx